import React from "react";

const WhatsAppWidget = () => {
  const phoneNumber = "0424888804"; // Phone number from the header
  const message =
    "Hello! I'm interested in your cleaning services. Can you help me?";

  return (
    <div className="whatsapp-widget">
      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
        <span className="whatsapp-tooltip">Chat with us</span>
      </a>
    </div>
  );
};

export default WhatsAppWidget;
